import * as ApiManager from './_manager';
import store from '@/store';

export const chatRoom = {
    listMembers: (payload) => {
        return ApiManager.callApi(
            `/member/company/${store.getters['company/getSelected']}/chat-room/${payload.chat_room_id}/members/list`,
            payload,
        );
    },
    updateMember: (payload) => {
        return ApiManager.callApi(
            `/member/company/${store.getters['company/getSelected']}/chat-room/${payload.chat_room_id}/members/${payload.member_id}/update`,
            payload,
        );
    },
}